<template>
  <checkbox-multi-select
    :label="label"
    :options="listGuestOptions"
    v-model="selected"
    trackBy="uuid"
    ref="multiSelectRef"
    displayField="display"
    @filtering="$emit('filtering', $event.text)"
    @select="selectItem"
    @open="$emit('open')"
    @close="$emit('close')"
    @removed="removedItem"
  >
  </checkbox-multi-select>
</template>
<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
export default {
  name: "student-select-component",
  components: { CheckboxMultiSelect },
  props: ["listGuestOptions", "label"],
  data() {
    return {
      selected: [],
      memorizedSelected: [],
      componentKey: null
    };
  },
  methods: {
    getMemorizedSelected() {
      return this.memorizedSelected;
    },
    setDefaultSelections() {
      this.selected = [];
    },
    selectItem(event) {
      this.memorizedSelected.push(event.itemData);
    },
    removedItem(event) {
      const { itemData } = event;
      this.memorizedSelected = this.memorizedSelected.filter(
        item => item !== itemData
      );
    }
  },
  watch: {
    listGuestOptions: function() {
      this.setDefaultSelections();
    }
  }
};
</script>
